import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";

import {
  ICreateBucketRequest,
} from "@shared/lib/types/influencer";
import { BucketService } from "../services/bucket.service";
import { BUCKET_LIST_QUERY_KEY } from "../constants";

export function useCreateBucket() {
  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: async (bucket: ICreateBucketRequest) => {
      return await BucketService.createBucket(bucket).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      queryKey: [BUCKET_LIST_QUERY_KEY],
      skipInvalidation: false,
    },
    onSuccess: (c, _) => {
      c.invalidateQueries({queryKey:BUCKET_LIST_QUERY_KEY})
    },
  });

  return {
    create,
    isCreating,
    isCreated,
  };
}
